import { useDynamicScripts } from "Components/Hooks/useDynamicScripts";

const HtmlBlock = ({ html }: { html: string }) => {
    // 🔑 run the hook BEFORE dangerously setting innerHTML
    useDynamicScripts(html);
  
    return <div dangerouslySetInnerHTML={{ __html: html }} />;
};
export default HtmlBlock;